import { render, staticRenderFns } from "./PrimaryButton.vue?vue&type=template&id=0e34d0ea&scoped=true&"
import script from "./PrimaryButton.vue?vue&type=script&lang=js&"
export * from "./PrimaryButton.vue?vue&type=script&lang=js&"
import style0 from "./PrimaryButton.vue?vue&type=style&index=0&id=0e34d0ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e34d0ea",
  null
  
)

export default component.exports